import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_PatternsLexemesTokensAttributes = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Patterns Lexemes-Tokens-Attributes"
    videos={[
      "https://www.youtube.com/embed/rRWzN219fsg",
    ]}
    takeaways={[]}
    questions={[
      'Find the tokens and total token count in following instructions printf("%d Hai",&x);',
      "Identify the lexemes that make up the tokens in the following program and give reasonable attribute values for the tokens.",
      `int main(X//To calculate the prime number 
for (j - 2: j -* num / 2; j+*) { 
if ((num % j) == OH 
flag = 1; 
break; 

if (flag == 0) 
printf("%d is a prime number \\n", num) 
else 
printf("%d is not a prime number \\n", num)`,
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_PatternsLexemesTokensAttributes;
